import { useParams } from 'react-router-dom';

import { initEligibleOfferOptionsSuccessAction } from 'containers/Snaps/Snap/store';
import { MilesTable } from 'components';

import { useGetRequest } from 'hooks';

import { DashboardEligibleOffer } from 'codegen';

import { columns } from './lib';

export const EligibleOffers = () => {
  const { snapId } = useParams();

  const { data, loading } = useGetRequest<DashboardEligibleOffer[]>({
    url: '/offers',
    queryParams: { snapId },
    options: {
      refreshDeps: [snapId],
      onSuccess: ({ data: offers }) => initEligibleOfferOptionsSuccessAction(offers),
    },
  });

  return (
    <MilesTable
      size='small'
      title='Eligible Offers'
      rowKey='offerName'
      loading={loading}
      columns={columns}
      dataSource={data}
    />
  );
};
